<template>
  <div class="mr_weatherBox">
    <div class="wb_title">天气</div>
    <div class="wb_list">
      <div class="wb_item" v-for="(item, index) in weatherInfo" :key="index">
        <div>{{ item.signalName }}</div>
        <div>
          {{ item.value }}<span>{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  StartCruiseFunc,
  LoadCruiseJsonFunc,
  LoadCruiseNetworkFunc,
  ParseRoamFunc,
  SwitchPauseTriggerFunc,
  ExitCruise,
} from "@/assets/js/unity3D/index.js";
export default {
  data() {
    return {
      weatherInfo: [],
    };
  },
  mounted() {
    this.getWeatherInfo();
  },
  unmounted() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    async getWeatherInfo() {
      try {
        const url = `${CONFIG.requestNameRoad}/digit/getSignalRealValue`;
        let res = await this.$apiUtils.get(url, {
          ledNo: "rf_rgb_led_1",
          customerId: this.$store.state.customerId,
        });
        if (res) {
          this.weatherInfo = res;
          console.log("getWeatherInfo", this.weatherInfo);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang='scss'>
.mr_weatherBox {
  width: 1200px;
  height: 180px;
  background: url("./img/panelView_blackBg_2_1.png") no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
  right: 0;
  top: 130px;
  margin: auto;
  .wb_title {
    position: absolute;
    top: 20px;
    text-align: center;
    font-size: 38px;
  }
}
</style>